<template>
  <Header :show="videoBoxStatus" :title="$t('videoList')" @close="_close">
    <div styleName="video_box_column video_box_common">
      <div styleName="video_box_column_name">{{ $t('videoName') }}</div>
      <div styleName="video_box_column_upload_time">{{ $t('uploadTime') }}</div>
      <div styleName="video_box_column_operate">{{ $t('operation') }}</div>
    </div>
    <ul styleName="video_box_content" v-if="videoList.length">
      <li v-for="(video, index) in videoList" :key="video.name" styleName="video_box_common video_box_content_item">
        <div styleName="video_box_column_name">{{video.fileName ? video.fileName : `video${index + 1}` }}</div>
        <div styleName="video_box_column_upload_time">{{ video.createTime | timestampToTime }}</div>
        <div styleName="video_box_column_operate">
          <button styleName="video_box_column_operate_btn" @click="_setCurrentVideoUrl(video.url)">{{ $t('open') }}</button>
        </div>
      </li>
    </ul>
    <div styleName="emityVideoList" v-else>{{ $t('noUploadedVideo') }}</div>
  </Header>
</template>

<script>
import styles from './index.scss'
import CSSModules from 'vue-css-modules'
import Header from './header'
import { mapGetters, mapActions } from 'vuex'
import * as types from '@/constants/index'
import { signalSdk } from '@/utils/getSDK'
import { timestampToTime } from '@/utils/timestampToTime'

export default {
  name: 'VideoBox',
  mixins: [CSSModules(styles)],
  filters: { timestampToTime },
  components: { Header },
  computed: {
    ...mapGetters(['videoBoxStatus', 'videoList', 'currentVideoUrl'])
  },
  created () {
    this.getVideoList()
  },
  methods: {
    ...mapActions([
      'getVideoList'
    ]),
    _close () {
      this.$store.commit(types.SET_VIDEO_BOX_STATUS, false)
    },
    _setCurrentVideoUrl (url) {
      this._close()
      console.log('url',url)
      console.log('this.currentVideoUrl',this.currentVideoUrl)
      if (this.currentVideoUrl === url) return
      if (this.currentVideoUrl !== url && this.currentVideoUrl) {
        signalSdk.sendCloseVideoMP4().then(() => {
          this.$store.commit(types.SET_VIDEO_URL, url)
          this.$store.commit(types.SET_VIDEO_STATUS, 2)
          setTimeout(() => {
            signalSdk.sendInitVideoMP4({
              url
            })
          }, 500)
        })
        return
      }
      this.$store.commit(types.SET_VIDEO_URL, url)
      this.$store.commit(types.SET_VIDEO_STATUS, 2)
      signalSdk.sendInitVideoMP4({
        url
      })
    }
  }
}
</script>
